import React, { forwardRef, useMemo } from "react";

// receipt: { id, poId, supplierName, items:[{itemId, qtyReceived, cost}], createdAt }
// itemsMap (facultatif): { [itemId]: { name, barcode } }
const ReceiptTicket = forwardRef(function ReceiptTicket(
  { receipt, itemsMap = {}, locationName = "" },
  ref
) {
  const totals = useMemo(() => {
    const qty = (receipt?.items || []).reduce(
      (s, it) => s + Number(it.qtyReceived || 0),
      0
    );
    const cost = (receipt?.items || []).reduce(
      (s, it) => s + Number(it.qtyReceived || 0) * Number(it.cost || 0),
      0
    );
    return { qty, cost };
  }, [receipt]);

  const created =
    receipt?.createdAt?.toDate?.() ||
    receipt?.createdAt ||
    new Date();

  return (
    <div ref={ref} className="p-3" style={{ maxWidth: 720, margin: "0 auto" }}>
      <div className="text-center mb-2">
        <h5 className="mb-0">Réception #{receipt?.id?.slice(0, 8) || "—"}</h5>
        <small className="text-muted">
          {new Date(created).toLocaleString()}
        </small>
      </div>

      <div className="mb-2 small">
        <div>
          <strong>PO:</strong> {receipt?.poId || "manual"}
        </div>
        {receipt?.supplierName ? (
          <div>
            <strong>Fournisseur:</strong> {receipt.supplierName}
          </div>
        ) : null}
        {locationName ? (
          <div>
            <strong>Emplacement:</strong> {locationName}
          </div>
        ) : null}
      </div>

      <div className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Article</th>
              <th>Code</th>
              <th className="text-end">Qté</th>
              <th className="text-end">Coût</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {(receipt?.items || []).map((it, idx) => {
              const meta = itemsMap[it.itemId] || {};
              const name = meta.name || it.itemId;
              const barcode = meta.barcode || "";
              const line =
                Number(it.qtyReceived || 0) * Number(it.cost || 0);
              return (
                <tr key={idx}>
                  <td>{name}</td>
                  <td className="text-muted">{barcode}</td>
                  <td className="text-end">
                    {Number(it.qtyReceived || 0).toLocaleString()}
                  </td>
                  <td className="text-end">
                    {Number(it.cost || 0).toLocaleString()} XOF
                  </td>
                  <td className="text-end">
                    {line.toLocaleString()} XOF
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={2} className="text-end">
                Totaux
              </td>
              <td className="text-end fw-bold">
                {totals.qty.toLocaleString()}
              </td>
              <td></td>
              <td className="text-end fw-bold">
                {totals.cost.toLocaleString()} XOF
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="text-center small text-muted">
        Merci — Conservez ce reçu pour vos dossiers.
      </div>
    </div>
  );
});

export default ReceiptTicket;
